import React, { useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTotalArticles } from "../../../hooks/useOrder";
import { displayPriceFormat } from "../../../utils";
import type { orderItemImagesProps } from "../../../1_types/orderTypes";
import { useResponsiveMaterial } from "../../../hooks/useResponsive";
import getStyles from "../Order.styles";
export const OrderItemImages = ({
  commande,
  totalPrice,
}: orderItemImagesProps) => {
  const [showAll, setShowAll] = useState(false);
  const isSmallScreen = useResponsiveMaterial("md", "down");
  const styles = getStyles()
  const totalItems = useTotalArticles(commande);
  const flatItems = useMemo(() => {
    if (!commande) return [];
    return Object.values(commande).flatMap((item) =>
      Array.from({ length: item.nb }).map((_, index) => ({
        ...item,
        _dupId: `${item.id}-${index}`,
      }))
    );
  }, [commande]);
  const imageItems = useMemo(() => {
    return flatItems.filter((item) => item.image && item.image.trim() !== "");
  }, [flatItems]);

  const PREVIEW_COUNT = 3;

  const previewImages = imageItems.slice(0, PREVIEW_COUNT);
  const remainingImages = imageItems.length - PREVIEW_COUNT;
  const visibleImages = showAll ? imageItems : previewImages;

  const hasImages = imageItems.length > 0;

  const ToggleBadge = ({ show, label, onClick }) => {
    if (!show) return null;

    return (
      <Box
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        sx={styles.orderBadge}
      >
        <Typography variant="body1">{label}</Typography>
      </Box>
    );
  };

  return (
    <div style={styles.left}>
      <Box
        sx={{
          ...styles.orderRow,
          gap: hasImages ? "8px" : "0px",
        }}
      >
        {!isSmallScreen && hasImages && (
          <Box sx={styles.orderImagesContainer}>
            {visibleImages.map((item) => (
              <Box
                key={item._dupId}
                sx={{
                  ...styles.orderImage,
                  backgroundImage: `url(${item.image})`,
                }}
              />
            ))}

            <ToggleBadge
              show={!showAll && remainingImages > 0}
              label={`+${remainingImages}`}
              onClick={() => totalPrice && setShowAll(true)}

            />

            <ToggleBadge
              show={showAll && imageItems.length > PREVIEW_COUNT}
              label="–"
              onClick={() => setShowAll(false)}

            />
          </Box>
        )}
        {totalPrice &&
          <Typography variant="body1" sx={styles.textWrap}>
            <b>
              {" "}
              {totalItems} Article{totalItems > 1 ? "s" : ""}
            </b>{" "}
            pour un total de <b> {displayPriceFormat(totalPrice)}</b>
          </Typography>
        }
      </Box>
    </div>
  );
};
